import { postsPath } from "@circle-react/helpers/urlHelpers";

import { t } from "@/i18n-js/instance";
import { anchorClassNames } from "@/react/helpers/cssAnchorHelpers";

interface LeaveCommentButtonProps {
  post: {
    slug: string;
    space_slug: string;
  };
}

export const LeaveCommentButton = ({ post }: LeaveCommentButtonProps) => {
  const { slug, space_slug: spaceSlug } = post || {};

  return (
    <div className="border-primary flex items-center justify-center gap-4 border-t p-12">
      <a
        className={anchorClassNames("btn btn-secondary")}
        href={postsPath({
          spaceSlug,
          slug,
        })}
      >
        {t("leave_a_comment")}
      </a>
    </div>
  );
};
